"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function SecondClause() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "secondClause"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, /*#__PURE__*/_react["default"].createElement("strong", null, "CL\xC1USULA SEGUNDA \u2013 DO PRAZO")), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, "2.1"), " O contrato ter\xE1 prazo de dura\xE7\xE3o de 30 (trinta) dias a contar da confirma\xE7\xE3o de pagamento. Decorrido esse prazo, o contrato permanecer\xE1 vigente por prazo indeterminado, sem a necessidade de nova contrata\xE7\xE3o, respeitadas as condi\xE7\xF5es detalhadas na", /*#__PURE__*/_react["default"].createElement("strong", null, " Cl\xE1usula Quarta.")));
}
var _default = SecondClause;
exports["default"] = _default;